document.addEventListener('click', event => {
  const menu = event.target.closest('.mobile-menu');
  document.querySelectorAll('.mobile-menu[open]').forEach(item => {
    if (item !== menu) item.removeAttribute('open');
  });
});
function prepareEnquiryForms() {
  document.querySelectorAll('.enquiry-form').forEach(form => {
    if (form.dataset.prepared) return;
    form.dataset.prepared = 'true';
    const subject = form.querySelector('[name="contact[subject]"]');
    if (!subject) return;
    const requested = new URLSearchParams(location.search).get('enquiry');
    if (!subject.value && [...subject.options].some(option => option.value === requested)) subject.value = requested;
    const eventTypes = ['Private event', 'Karma mobile bar', 'Workshop or training'];
    const fieldset = form.querySelector('.event-fields');
    const sync = () => {
      const active = eventTypes.includes(subject.value);
      if (fieldset) { fieldset.hidden = !active; fieldset.disabled = !active; }
      ['Date', 'Guests', 'Budget', 'Service'].forEach(key => {
        const input = form.elements.namedItem('contact[' + key + ']');
        if (input) {
          input.required = active;
          input.setAttribute('aria-required', String(active));
        }
      });
    };
    subject.addEventListener('change', sync);
    sync();
    form.addEventListener('input', event => {
      if (event.target.setCustomValidity) event.target.setCustomValidity('');
    });
    form.addEventListener('submit', event => {
      form.querySelectorAll('input[required]:not([disabled]),textarea[required]').forEach(input => {
        if (input.type !== 'date' && !input.value.trim()) input.setCustomValidity('Please complete this field.');
      });
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
    });
  });
}
document.addEventListener('DOMContentLoaded', prepareEnquiryForms);
document.addEventListener('shopify:section:load', prepareEnquiryForms);
prepareEnquiryForms();
